export default __webpack_public_path__ + "static/media/down.17ab3450.svg";